import type { FC } from "react";
import React from "react";
import { Box, Flex } from "@edreamsodigeo/prisma-design-system";
import { createFeature } from "@edreamsodigeo/frontend-core";

import { getAutoRenewalPolicy } from "~/components/common/MembershipWithInstallmentsDisclaimer/tools/utils";
import type { SubscriptionResponse } from "~/generated/graphql";
import MembershipWithInstallmentsDisclaimer from "~/components/common/MembershipWithInstallmentsDisclaimer/MembershipWithInstallmentsDisclaimer";
import { EQUAL_PROMINENCE_MOBILE } from "~/clientState/ab/teams/primo";

const YearlyWithMonthlyDisclaimerBody: FC<{
  offer: SubscriptionResponse;
}> = ({ offer }) => {
  const autoRenewalPolicy = getAutoRenewalPolicy(offer);

  return autoRenewalPolicy ? (
    <MembershipWithInstallmentsDisclaimer
      autoRenewalPolicy={autoRenewalPolicy}
    />
  ) : null;
};

const YearlyWithMonthlyDisclaimerBlock: FC<{
  offer: SubscriptionResponse;
}> = ({ offer }) => (
  <Flex>
    <YearlyWithMonthlyDisclaimerBody offer={offer} />
  </Flex>
);

const YearlyWithMonthlyDisclaimerInline: FC<{
  offer: SubscriptionResponse;
}> = ({ offer }) => (
  <Box display={"inline"} data-testid={"YWMDisclaimerInlineSpace"}>
    {" "}
    <YearlyWithMonthlyDisclaimerBody offer={offer} />
  </Box>
);

export const YearlyWithMonthlyDisclaimer = createFeature({
  name: EQUAL_PROMINENCE_MOBILE,
  variations: [
    YearlyWithMonthlyDisclaimerBlock,
    YearlyWithMonthlyDisclaimerBlock,
    YearlyWithMonthlyDisclaimerBlock,
    YearlyWithMonthlyDisclaimerInline,
  ],
  version: 1,
});
